import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import { useEffect, useRef, useState } from "react";

import { getAvatar } from "utils/getAvatar";
import sanitizeHtml from "sanitize-html";
import { Avatar } from "@mui/material";
import { convertToLetters } from "utils/convertToLetters";
import moment from "moment";

const UserCard: FC<Props> = ({ client }) => {
  const { t } = useTranslation();
  const { clientId } = useParams();
  const hasAvatar = false;

  const [, setAv] = useState<null>(null);

  const fetchAvatar = async () => {
    setAv(await getAvatar(client!.Id!));
  };

  useEffect(() => {
    if (!hasAvatar) return;
    fetchAvatar();
  }, [hasAvatar]);

  const rippleContainerRef = useRef(null);

  const createRipple = (event: MouseEvent) => {
    const container = rippleContainerRef.current as HTMLElement;
    if (!container) return;

    // Usuń poprzedni ripple, jeśli istnieje
    const oldRipple = container.querySelector(`.${styles.ripple}`);
    if (oldRipple) {
      oldRipple.remove();
    }

    // Utwórz nowy element ripple
    const ripple = document.createElement("span");
    const diameter = Math.max(container.clientWidth, container.clientHeight);
    const radius = diameter / 2;

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${event.clientX - container.offsetLeft - radius}px`;
    ripple.style.top = `${event.clientY - container.offsetTop - radius}px`;
    ripple.classList.add(styles.ripple);

    // Dodaj ripple do kontenera
    container.appendChild(ripple);

    // Usuń ripple po zakończeniu animacji (600ms)
    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  return (
    <div
      ref={rippleContainerRef}
      onClick={(e) => {
        createRipple(e);
      }}
      className={`${styles.wrapper} ${styles.rippleContainer} ${
        clientId === client?.Id?.toString() && styles.active
      }`}
    >
      <div
        // onClick={() => navigate(`/clients/${filterId}/${client.Id}`)}
        className={`${styles.card}`}
      >
        <div className={styles.ID}>
          <Avatar className={styles.avatar}>
            {convertToLetters(
              client.Label?.replaceAll("<em>", "")?.replaceAll("</em>", "")
            ) ?? ""}
          </Avatar>

          <div className={styles.data}>
            <div
              className={styles.name}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(client.Label ?? t("common.noLabel")),
              }}
            ></div>
            <div className={styles.tag}>
              {/* <TagBadge
                tag={{
                  Id: '1',
                  Flags: 1,
                  Name: 'WSPÓŁPRACOWNIK',
                  Global: true,
                  Type: 1,
                  WorkspaceId: ' ',
                }}
              /> */}
            </div>
          </div>
        </div>
        <div className={styles.icons}>
          {moment(client.CreationDate).format("DD.MM.yyyy | HH:mm")}
          {/* <ClientIconState client={client} /> */}
        </div>
      </div>
    </div>
  );
};

export default UserCard;
